module.exports = __webpack_public_path__ + "img/3.600d93a9.jpg";